import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ReportViewComponent } from '@app/main/report-view/report-view.component';
import { MsalGuard } from '@azure/msal-angular';

const routes: Routes = [
    {
        path: '',
        component: ReportViewComponent,
        pathMatch: 'full',
        canActivate: [MsalGuard]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ReportViewRoutingModule {}
